import { match } from 'ts-pattern';
import { IngredientType } from '@modules/libs/graphql/generated/graphql';
import { BrandType } from '@shared/types/brand.type';
export const mapIngredientTypeToDomain = (type: IngredientType): BrandType => {
  return match(type).with(IngredientType.Product, () => BrandType.Cp).with(IngredientType.NonProduct, IngredientType.Other, () => BrandType.Other).exhaustive();
};